<template>
  <CollapseItems
    :padding-container-header="'p-3'"
    :collapse-body-background="'bg-light'"
  >
    <template #title>
      <v-row
        justify="space-between"
        style="width: 85vw;"
      >
        <v-col
          md="3"
          class="d-flex align-center"
        >
          <h5 class="font-weight-black">
            Áreas de interesse
          </h5>
        </v-col>
        <v-col
          md="9"
          class="d-flex justify-sm-end flex-wrap"
        >
          <h6 class="p-2 pr-0 font-weight-bold m-0 mr-5 d-flex align-center">
            Escolha uma área:
          </h6>
          <v-chip-group
            v-model="trail_id"
            active-class="nitro"
            color="white"
          >
            <v-chip
              v-for="loop_trail in trails"
              :key="loop_trail.id"
              :value="loop_trail.id"
            >
              {{ loop_trail.acronym }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>
    </template>
    <template #content>
      <div class="p-3">
        <v-row v-if="trail && trails.length && blocks.length">
          <v-col
            v-for="block in blocks"
            :key="block.id"
            :sm="6"
            :md="4"
            :cols="12"
            style="max-width: 538px"
          >
            <CardThemeBlock
              :trail="trail"
              :block="block"
            />
          </v-col>
        </v-row>
        <div
          v-else-if="trail && trails.length && blocks.length == 0"
          style="min-height: 200px"
          class="d-flex align-center justify-center"
        >
          <div style="border-style: dashed; padding: 20px;">
            <p>Você não tem módulos disponíveis para <b>{{ trail.name }}</b>. Por favor, selecione módulos de outra carreira.</p>
          </div>
        </div>
        <div
          v-else
          style="min-height: 200px"
          class="d-flex align-center justify-center"
        >
          <div style="border-style: dashed; padding: 20px;">
            NAVEGUE PELAS CARREIRAS
          </div>
        </div>
        <div class="p-4 d-flex flex-column flex-md-row justify-content-md-center align-items-md-center">
          <v-btn
            outlined
            class="mr-1 border-nitro text-nitro"
            @click="onCancel"
          >
            Escolher depois
          </v-btn>
          <v-btn
            color="nitro"
            :disabled="!selectedBlocks.length || selectedBlocks.length != selectedCycle.blocks_qty"
            class="text-white"
            @click="onConfirm"
          >
            Continuar conteúdo ({{ selectedBlocks.length }} / {{ selectedCycle.blocks_qty }})
          </v-btn>
        </div>
      </div>
    </template>
  </CollapseItems>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import CardThemeBlock from '@/student/pages/module/components/CardThemeBlock.vue';
import CollapseItems from "@/common/components/CollapseItems.vue";
export default {
  components:{
    CardThemeBlock,
    CollapseItems,
  },
  computed: {
    trail_id:{
      get(){
        return this.$store.state.trail.selected_trail_id
      },
      set(value){
        this.$store.state.trail.selected_trail_id = value
      }
    },
    ...mapGetters(['trails', 'selectedBlocks','selectedCycle']),
      trail(){
        return this.trails.find(t => t.id == this.trail_id)
      },
      blocks(){
        return this.trail ? this.trail.blocks.length ? this.trail.blocks : [] : []
      },
  },

  watch:{
    trail_id(){
      this.RESET_SELECTED_BLOCKS()
    }
  },
  created(){
    if(this.trails.length === 0)
      this.getTrails()
  },
  methods: {
    ...mapMutations(['SET_TRAILS', 'SET_SELECTION_BLOCKS', 'RESET_SELECTED_BLOCKS']),
    ...mapActions(['getTrails']),
    onCancel(){
      this.RESET_SELECTED_BLOCKS();
      this.$emit('onCancel');
    },
    onConfirm(){
      this.$emit('onConfirm')
    }
  }
}
</script>
